import {z} from 'zod';

// A warranty assignment entered on the create form before the vehicle exists. Dates are kept in
// the API date-time string format so the row can be posted as-is once the vehicle id is known.
export const VehicleWarrantyRowSchema = z.object({
  warrantyProductId: z.string(),
  startDate: z.string(),
  endDate: z.string().nullable(),
  startOdometerKm: z.number().nullable(),
  endOdometerKm: z.number().nullable(),
});

export type VehicleWarrantyRow = z.infer<typeof VehicleWarrantyRowSchema>;
